import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import { publishSdkEvent } from './publishSdkEvent';

const openRegistrationModal = () => {
  publishSdkEvent({
    event: 'OpenRegistrationScreen',
    data: {
      source: MINIAPP_PACKAGE_ID,
      action: 'click',
      action_button: MINIAPP_PACKAGE_ID,
    },
  });
};

export { openRegistrationModal };
